import AbstractHTML5Player from '../AbstractHTML5Player';
import * as playerConstants from '../../../utils/playerConstants';
import Utils from '../../../utils/Utils';
import shakaPlayer from './shakaMain';
import shakaAssets from './shakaAsset';
import ShakaLib from './ShakaLib';
import logger from 'src/utils/logger/logger';

class AAFShakaPlayer extends AbstractHTML5Player {
  constructor() {
    super();

    //shaka.polyfill.installAll(); <-- se pasa a ShakaLib.js

    this.createAssetInfo = this.createAssetInfo.bind(this);
    this.setAudioTrack = this.setAudioTrack.bind(this);

    this.canPlay = false;
    this.handleStreamingError = this.handleStreamingError.bind(this);
  }

  getStreamType() {
    switch (this.options.streamType) {
      case playerConstants.HLS:
        return 'application/vnd.apple.mpegurl';
        break;
      case playerConstants.AUDIO:
      case playerConstants.RADIO:
        return 'audio/mp4';
        break;
      case playerConstants.SS:
      case playerConstants.SS_MA:
        return 'application/vnd.ms-playready.initiator+xml';
        break;
      default:
        return null;
        break;
    }
  }

  createPlayer(options) {
    const shaka = ShakaLib.getShakaObject();
    this.prependPip = options.isPip ? '_pip' : '_full';
    this._playerContainer = window.document.createElement('div');
    this._playerContainer.style.backgroundColor = 'transparent';
    this._playerContainer.id = `Html5PlayerContainer${this.prependPip}`;
    this._playerContainer.className = 'Html5PlayerContainer';

    if (!this.streamIsImage()) {
      this.setPlayerBackground(options.backgroundImage ? options.backgroundImage : null);

      this._playerHTMLTag = window.document.createElement('video');
      this._playerHTMLTag.setAttribute('id', `Html5Player${this.prependPip}`);

      // Muted only apply to pip, at this moment
      if (options.muted) {
        this._playerHTMLTag.setAttribute('muted', 'muted');
      }

      this._playerHTMLTag.className = 'Html5Player';
      shakaPlayer.setVideo(this._playerHTMLTag);

      const playerShakaLocal = new shaka.Player(this._playerHTMLTag);
      shakaPlayer.setPlayer(playerShakaLocal);
      window.Player = playerShakaLocal;
      playerShakaLocal.addEventListener('error', () => {
        playerShakaLocal.retryStreaming();
      });
      this._playerContainer.appendChild(this._playerHTMLTag);
    } else {
      this.setPlayerBackground(options.src ? options.src : null);
    }

    if (!this.options.parentWrapper) {
      logger.error('parentWrapper not found');
      return;
    }

    const vWrapper = document.getElementById(this.options.parentWrapper.id);
    // vWrapper.appendChild(this._playerContainer);
    vWrapper.insertBefore(this._playerContainer, vWrapper.firstChild);

    // Add listeners...if apply
    if (!this.streamIsImage()) {
      this.addEventsListeners();
    }
  }

  createMedia(options) {
    const shaka = ShakaLib.getShakaObject();
    this.typeFilter = shakaAssets.getTypeFilter();

    // options.src = "https://storage.googleapis.com/shaka-demo-assets/angel-one/dash.mpd";
    if (this._isPrepared || !shaka.Player.isBrowserSupported()) return;

    if (options.newSource && options.newSource.src) {
      options.newSource = null;
    }

    this.options = options;
    if (this.options.isPip) {
      // Pip would only exist when this is a video or audio
      this._playerHTMLTag = document.getElementById('Html5Player_pip');
      if (!this._playerHTMLTag) {
        this.createPlayer(options);
      } else {
        this.addEventsListeners();
        this._playerContainer = document.getElementById('Html5PlayerContainer_pip');
        if (!this.streamIsImage()) {
          this.setPlayerBackground(
            options.backgroundImage ? options.backgroundImage : null
          );
        }
        if (options.muted) {
          this._playerHTMLTag.setAttribute('muted', 'muted');
        } else {
          this._playerHTMLTag.removeAttribute('muted');
        }
        if (options.controls) {
          this._playerHTMLTag.setAttribute('controls', 'controls');
        } else {
          this._playerHTMLTag.removeAttribute('controls');
        }
      }
    } else {
      this.createPlayer(options);
    }

    this.hide();
    this._isPrepared = true;
  }

  createAssetInfo() {
    let typeFilter = this.typeFilter.DEFAULT;

    if (this.options.provider == 'FOX' && !this.options.isLive)
      typeFilter = this.typeFilter.FOXPLAY;
    if (this.options.provider == 'FOX V3' && !this.options.isLive)
      typeFilter = this.typeFilter.FOXV3PLAY;
    if (this.options.provider == 'HBO' && !this.options.isLive)
      typeFilter = this.typeFilter.HBO;
    if (this.options.provider === 'CRACKLE' && !this.options.isLive) {
      typeFilter = this.typeFilter.CRACKLE;
      this.options.drmInfo.resultCert = undefined;
    }
    if (this.options.provider === 'PICARDIA' && !this.options.isLive) {
      typeFilter = this.typeFilter.PICARDIA;
      this.options.drmInfo.resultCert = undefined;
    }

    let token = null;
    if (this.options.drmInfo && this.options.drmInfo.challenge) {
      if (Utils.isJson(this.options.drmInfo.challenge)) {
        const challenge = JSON.parse(this.options.drmInfo.challenge);
        token = challenge.token;
      } else {
        token = this.options.drmInfo.challenge;
      }
    }

    const AssetInfo = {
      manifestUri: this.options.src,
      licenseServers: {
        'com.widevine.alpha': this.options.drmInfo.server_url,
        'com.microsoft.playready': this.options.drmInfo.server_url
      },

      drm: {
        advanced: {
          'com.widevine.alpha': {
            serverCertificate: this.options.drmInfo.resultCert
          }
        }
      },
      requestFilter: shakaAssets.DLARequestFilter,
      responseFilter: shakaAssets.DLAResponseFilter,
      customData: {
        token,
        device_id: this.options.drmInfo.device_id
      },
      typeFilter,
      needBody : true
    };

    if (!this.options.isLive) {
      AssetInfo.bufferBehind = 5;
      AssetInfo.streamBufferSize = 10; // se configurra por ambiante
    }

    if (this.options.provider && this.options.provider.toLowerCase() === 'hbov2' && this.options.currentContentType === 'content_is_vod'){
      delete AssetInfo.customData;
      delete AssetInfo.typeFilter;
      //Se usa para chequear que mande o no body dependiendo si es v1 o v3
      AssetInfo.needBody = false;
    }

    shakaAssets.setAssetInfo(AssetInfo);
    return AssetInfo;
  }

  /**
   * Arrives here from segment loading error (video freeze), so we send message to screen and show
   * a retry option to user (if user dont use retry, then could do a close modal and do a seek
   * for get alive the streaming again)
   *
   * @param {*} err shaka error object, see https://shaka-player-demo.appspot.com/docs/api/shaka.util.Error.html
   *
   */
  handleStreamingError(err) {
    if (this.options.events.onError && err.code != 2004) {
      // Text to move to apa?
      const msg = 'Network timeout error, can not load video segments';
      this.options.events.onError(msg, playerConstants.onRenderError);
    }
  }

  loadMedia() {
    const player = shakaPlayer.getPlayer();

    if (!this._isPrepared) {
      return false;
    }
    if (this.streamIsImage()) {
      return;
    }

    if (this.options.resume && !this.options.isLive) {
      this.seek_resume = this.options.resume;
    }

    this.assetInfo = this.createAssetInfo();
    const asset = shakaPlayer.preparePlayer(this.assetInfo, this.handleStreamingError);

    const initConfig = {
      abr: {
        defaultBandwidthEstimate: 10e5,
        bandwidthUpgradeTarget: 0.7,
        bandwidthDowngradeTarget: 1.3
      }
    };

    player.configure(initConfig);

    if (this.options.src) {
      this.src = this.options.src;
      this._isOnLoaded = false;
      player
        .load(this.options.src, this.seek_resume)
        .then(() => {
          this.seek_resume = 0;
          this.setTextTrack(player);
          // this.updateQualityOptions(null, shakaPlayer.getTracks('video'));
        })
        .catch(e => {
          logger.debug('shaka load error', e); // Error already handled through error event.;
          this._onError(e);
        });

      if (!this.options.isPip) {
        this.setPlayerFull();
      }
    } else {
      this.destroy();
    }

    /**
     * only for testing
     */
    // setTimeout(() => {
    //     console.log('[*******************] simulando error');
    //     const err  = {
    //         severity: 2,
    //         category: 1,
    //         code: 1003
    //     };
    //     this.handleStreamingError(err);
    // }, 15000)
  }

  _onError(e) {
    logger.debug('[PLAYR EVENT] _onError');
    logger.debug(e);
    // From https://dev.w3.org/html5/spec-author-view/video.html
    let msg = '';

    if (e && e.target && e.target.error && e.target.error.code) {
      switch (e.target.error.code) {
        case e.target.error.MEDIA_ERR_ABORTED:
          msg = 'User aborted the video playback.';
          break;
        case e.target.error.MEDIA_ERR_NETWORK:
          msg = 'A network error caused the video download to fail part-way.';
          break;
        case e.target.error.MEDIA_ERR_DECODE:
          msg =
            'The video playback was aborted due to a corruption problem or because the video used features your browser did not support.';
          break;
        case e.target.error.MEDIA_ERR_SRC_NOT_SUPPORTED:
          msg =
            'The media resource indicated by the src attribute or assigned media provider object was not suitable.';
          break;
        default:
          msg = 'An unknown error occurred.';
          break;
      }
    } else {
      if (e && e.code) {
        let code = this.getCodeError(e.code);
        let severity = 'SEVERITY unrecognized';
        let category = 'CATEGORY unrecognized';

        if (e && e.severity) {
          severity = this.getSeverityError(e.severity);
        }

        if (e && e.category) {
          category = this.getCategoryError(e.category);
        }

        msg =
          'error when try to load media content | [' +
          code +
          ' | ' +
          severity +
          ' | ' +
          category +
          ']';
      }
    }

    this.stop();

    if (this.options.events.onError && e.code != 2004) {
      this.options.events.onError(msg, playerConstants.onRenderError);
    }
  }

  getCategoryError(category) {
    switch (category) {
      case 1:
        category = 'CAT 1 - NETWORK - Errors from the network stack';
        break;
      case 2:
        category = 'CAT 2 - TEXT - Errors parsing text streams';
        break;
      case 3:
        category = 'CAT 3 - MEDIA - Errors parsing or processing audio or video streams';
        break;
      case 4:
        category = 'CAT 4 - MANIFEST - Errors parsing the Manifest';
        break;
      case 5:
        category = 'CAT 5 - STREAMING - Errors related to streaming';
        break;
      case 6:
        category = 'CAT 6 - DRM - Errors related to DRM';
        break;
      case 7:
        category = 'CAT 7 - PLAYER - Miscellaneous errors from the player';
        break;
      case 8:
        category = 'CAT 8 - CAST - Errors related to cast';
        break;
      case 9:
        category = 'CAT 9 - STORAGE - Errors in the database storage (offline)';
        break;

      default:
        break;
    }

    return category;
  }

  getSeverityError(severity) {
    switch (severity) {
      case 1:
        severity = 'SEVERITY 1 - RECOVERABLE';
        break;
      case 2:
        severity = 'SEVERITY 2 - CRITICAL';
        break;
      default:
        break;
    }

    return severity;
  }

  getCodeError(code) {
    switch (code) {
      case 1000:
        code = 'CODE 1000 - UNSUPPORTED_SCHEME';
        break;
      case 1001:
        code = 'CODE 1001 - BAD_HTTP_STATUS';
        break;
      case 1002:
        code = 'CODE 1002 - HTTP_ERROR';
        break;
      case 1003:
        code = 'CODE 1003 - TIMEOUT';
        break;
      case 1004:
        code = 'CODE 1004 - MALFORMED_DATA_URI';
        break;

      case 4001:
        code = 'CODE 4001 - DASH_INVALID_XML';
        break;
      case 4002:
        code = 'CODE 4002 - DASH_NO_SEGMENT_INFO';
        break;
      case 4003:
        code = 'CODE 4003 - DASH_EMPTY_ADAPTATION_SET';
        break;
      case 4004:
        code = 'CODE 4004 - DASH_EMPTY_PERIOD';
        break;
      case 4005:
        code = 'CODE 4005 - DASH_WEBM_MISSING_INIT';
        break;
      case 4006:
        code = 'CODE 4006 - DASH_UNSUPPORTED_CONTAINER';
        break;
      case 4007:
        code = 'CODE 4007 - DASH_PSSH_BAD_ENCODING';
        break;
      case 4008:
        code = 'CODE 4008 - DASH_NO_COMMON_KEY_SYSTEM';
        break;
      case 4009:
        code = 'CODE 4009 - DASH_MULTIPLE_KEY_IDS_NOT_SUPPORTED';
        break;
      case 4010:
        code = 'CODE 4010 - DASH_CONFLICTING_KEY_IDS';
        break;
      case 4011:
        code = 'CODE 4011 - UNPLAYABLE_PERIOD';
        break;

      case 6000:
        code = 'CODE 6000 - NO_RECOGNIZED_KEY_SYSTEMS';
        break;
      case 6001:
        code = 'CODE 6001 - REQUESTED_KEY_SYSTEM_CONFIG_UNAVAILABLE';
        break;
      case 6002:
        code = 'CODE 6002 - FAILED_TO_CREATE_CDM';
        break;
      case 6003:
        code = 'CODE 6003 - FAILED_TO_ATTACH_TO_VIDEO';
        break;
      case 6004:
        code = 'CODE 6004 - INVALID_SERVER_CERTIFICATE';
        break;
      case 6005:
        code = 'CODE 6005 - FAILED_TO_CREATE_SESSION';
        break;
      case 6006:
        code = 'CODE 6006 - FAILED_TO_GENERATE_LICENSE_REQUEST';
        break;
      case 6007:
        code = 'CODE 6007 - LICENSE_REQUEST_FAILED';
        break;
      case 6008:
        code = 'CODE 6008 - LICENSE_RESPONSE_REJECTED';
        break;
      case 6010:
        code = 'CODE 6010 - ENCRYPTED_CONTENT_WITHOUT_DRM_INFO';
        break;
      case 6012:
        code = 'CODE 6012 - NO_LICENSE_SERVER_GIVEN';
        break;
      case 6013:
        code = 'CODE 6013 - OFFLINE_SESSION_REMOVED';
        break;
      case 6014:
        code = 'CODE 6014 - LICENSE_HAS_EXPIRED';
        break;
      case 6015:
        code = 'CODE 6015 - SERVER_CERTIFICATE_REQUIRED';
        break;

      case 7000:
        code = 'CODE 7000 - LOAD_INTERRUPTED';
        break;
      case 7001:
        code = 'CODE 7001 - OPERATION_ABORTED';
        break;
      case 7002:
        code = 'CODE 7002 - NO_VIDEO_ELEMENT';
        break;

      default:
        break;
    }

    return code;
  }

  setTextTrack(player) {
    const lengOptions =
      this.options.multipleLangOptions &&
      this.options.multipleLangOptions.subtitles &&
      this.options.multipleLangOptions.subtitles.options;
    if (Utils.isObject(lengOptions)) {
      for (const o in lengOptions) {
        player &&
        player.addTextTrack(
          lengOptions[o].external,
          `${lengOptions[o].internal}_ext`,
          'subtitle',
          'text/vtt'
        );
      }
    }
  }

  setAudioTrack(codeTrack) {
    const player_ = shakaPlayer.getPlayer();

    return new Promise((resolve, reject) => {
      logger.debug('[Arris] Enter audioTrack');
      if (this.currentAudioTrackIndex === codeTrack) {
        logger.info('[Arris] Same audioTrack, nothing to do', this.currentAudioTrackIndex);
        resolve(true);
      }
      this.currentAudioTrackIndex = codeTrack;
      try {
        logger.info('[Arris] change audioTrack', codeTrack);
        if (player_ && player_.selectAudioLanguage) {
          player_.selectAudioLanguage(codeTrack);
          super.play();
        }
      } catch (e) {
        logger.debug('[Arris] error when change lang', codeTrack);
        reject('[Arris] error when change lang');
      }
      resolve(true);
    });
  }

  _onCanPlay(e) {
    logger.debug('[ARRIS] _onCanPlay Arris> ');
    if (this.options.events.onCanPlay) {
      this.options.events.onCanPlay(e);
    }
    if (this.canPlay) return;

    logger.debug('[ARRIS] se manda a play');
    this.canPlay = true;
    super.play();
  }

  /**
   * Arris no manda a play al inicio, esperamos al primer onCanplay recibido por la app
   * Are you sure send the load event before? it is a must
   */
  play() {
    logger.debug('[ARRIS] Player recibe play');
    if (this.streamIsImage()) {
      return;
    }
    this.show();
  }

  destroy() {
    if (!this._isPrepared) {
      return;
    }
    this.canPlay = false;
    super.destroy();
  }

  replaceMediaSource(newSource) {
    this.canPlay = false;
    super.replaceMediaSource(newSource);
  }
}

export default AAFShakaPlayer;



// WEBPACK FOOTER //
// ./src/devices/all/shakaPlayer/AAFShakaPlayer.js